module.exports = __webpack_public_path__ + "img/infographicWhoWeAreHorisontalHome.0a2703a1.webp";